import { getExternalURL } from "./getExternalURL";

export type GetExternalCrossSellingQuoteFormURL = (
  countryCode: string,
  formId: string
) => string | undefined;

export const getExternalCrossSellingQuoteFormURL: GetExternalCrossSellingQuoteFormURL = (
  countryCode,
  formId = ""
) => {
  const externalURL = getExternalURL(`${countryCode}.ci.crossSellingQuoteForm`, { formId });
  return externalURL ? externalURL : undefined;
};
